import { render, staticRenderFns } from "./viewImage-fy.vue?vue&type=template&id=fb077f62"
import script from "./viewImage-fy.vue?vue&type=script&lang=js"
export * from "./viewImage-fy.vue?vue&type=script&lang=js"
import style0 from "./viewImage-fy.vue?vue&type=style&index=0&id=fb077f62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports